@use "ui/styles/colorsOld";
@use "ui/styles/effects";

.wrapper {
  position: relative;

  .searchInput {
    padding-left: 1.9em;
    padding-right: 1.7em;
  }

  .searchIcon {
    width: 1.5em;
    height: 1.5em;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 5px;
    z-index: 2;
    color: var(--secondary-text-color);
  }

  .clearIcon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 4px;
    color: var(--secondary-text-color);
    @include effects.iconButton
  }

  &.fullWidth {
    width: 100%;
  }

  &.transparentInput {
    .searchIcon {
      left: 0;
    }

    .clearIcon {
      right: 0
    }

    .searchInput {
      padding-left: calc(1.9em - 5px);
      padding-right: calc(1.7em - 4px);
    }
  }

  // when SearchInput is used in a header - should be merged with SearchBar component
  // TODO: revisit this
  &.headerStyle {
    margin-right: 12px;

    &:hover input {
      border-color: colorsOld.$stoneLightX1;
    }

    input {
      height: 38px;
      border-color: transparent;
      padding: 9px 16px 9px 30px; // using absolute dimensions to match icon sizes
      border-left-color: colorsOld.$stoneLightX1;
      text-overflow: ellipsis;

      &:not(:active, :focus, :hover) {
        border-radius: 0;
      }

      &:active,
      &:focus {
        border-color: colorsOld.$sapphireLight;
      }

      &::placeholder {
        color: colorsOld.$stoneDark;
      }
    }
  }
}